module.exports = __webpack_public_path__ + "static/media/CountrySearch.55f50df5.svg";